import {$controller} from "rapid/index";
import {clone, delay} from "lodash";
import {InviteNewController} from "./invite-new/invite-new";
import InviteNewTemplate from "./invite-new/invite-new.html";

const dependencies = ["$Users", "$Company", "$Invitations"];

export default class Controller extends $controller {

    constructor($injector, $scope, $state, $stateParams, $ToastService, $UndoDeleteService, $auth, $mdDialog) {
        "ngInject";
        super($injector, dependencies);
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.toastService = $ToastService;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.selectFilter = {};
        this.$scope.users = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.undoDelete = $UndoDeleteService;
        this.$auth = $auth;
        this.$mdDialog = $mdDialog;
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };
    }

    $onInit() {
        this.$scope.filter.show = false;
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        if (this.$stateParams.createdCompany) {
           this.openInviteDialog(null, this.$stateParams.createdCompany);
        }
        document.addEventListener("keypress", this.searchByKeyPress);
    }

    $onDestroy() {
        document.removeEventListener("keypress", this.searchByKeyPress);
    }


    query(isNew) {
        this.$scope.query.page = isNew ? 1 : this.$scope.query.page;

        var users = this.$Users.query(this.$scope.query);
        this.$scope.loading = true;

        users.$promise.then((resp) => {
            isNew ? this.$scope.users = resp : this.$scope.users.push(...resp);
            this.$scope.loading = false;
            this.$scope.pageCount = resp._meta.page_count;

            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;

        });
    }

    removeFilter() {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);

    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);

            }
        }, 500);
    }

    transformGroupsView(arr) {
        return arr.join(", ");
    }

    openInviteDialog(item, selectedCompany) {
        let companies = this.$Company.query({page_size: 100});
        companies.$promise.then((resp) => {
            let parentEl = angular.element(document.body);
            this.$mdDialog.show({
                parent: parentEl,
                title: "Create new configuration",
                controller: InviteNewController,
                template: InviteNewTemplate,
                targetEvent: item,
                locals: {
                    callback: (invitation) => { this.sendInvitation(invitation); },
                    companiesArray: resp,
                    selectedCompany: selectedCompany
                }
            });
        }).catch(() => {
            this.toastService.showError(`Can't send invitation.`, 5000);
        });
    }

    sendInvitation(invitation) {
        let invite = this.$Invitations.create(invitation);
        invite.$promise.then(() => {
            this.toastService.showSimple(`Invitation sent.`, 5000);
        }).catch(() =>{
            this.toastService.showError(`Can't send invitation.`);
        });
    }

    resetPassword(email) {
        this.$auth.$http({
            url: "/api/password/reset/",
            method: "POST",
            data: {email}
            }).then(
            () => {
                this.toastService.showSimple(`Reset link sent.`, 5000);
            },
            () => {
                this.toastService.showError(`Can't reset password.`);
            }
        );
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    checkAccount(deletedUserEmail, callback) {
        const currentUser = this.$auth.getUser();
        const currentUserEmail = currentUser ? currentUser.email : null;

        if (currentUserEmail && currentUserEmail === deletedUserEmail) {
            const confirm = this.$mdDialog.confirm()
                .title("Warning")
                .textContent("You are trying to delete your own account. After this your access to UpReach cloud may be lost!")
                .ariaLabel("Own Account Delete")
                .ok("DELETE")
                .cancel("CANCEL");
            this.$mdDialog.show(confirm).then(() => {
                callback(true);
            }).catch(() => {});

        } else {
            callback(false);
        }
    }

    deleteUser(user) {
        this.checkAccount(user.email, (isOwnAccount) => {
            user.$delete().then(() => {
                if (!isOwnAccount) {
                    this.toastService.deleteToast(`Deleted user ${user.first_name} ${user.last_name}`, () => {
                        this.undoDelete.undoDelete("users", this.$filter("getObjectId")(user.url)).then(() => {
                            this.toastService.showSimple(`Deletion undone`, 5000);
                            this.query(true);
                        }).catch(() => {
                            this.toastService.showError(`Could not undone deletion`, 5000);
                        });
                    });
                    this.query(true);
                } else {
                    this.$auth.logout();
                }
            }, () => {
                this.toastService.showError(`Can't delete user!`, 5000);
            });
        });
    }

    setTwoFactorAuth(two_factor_enabled, id) {
        const userId = id.split("/api/users/")[1].split("/")[0];
        const twoFactorEnabled = two_factor_enabled;
        this.$auth.twoFactorAuthenticationState({enable: !two_factor_enabled, user: userId})
            .then((resp) => {
                const userIndex = this.$scope.users.findIndex(item => item.url === id);
                if (userIndex !== -1) {
                    this.$scope.users[userIndex].two_factor_enabled = !this.$scope.users[userIndex].two_factor_enabled;
                }
                const msg = resp && resp.detail ? resp.detail : `2Factor is ${!two_factor_enabled}`;
                if (twoFactorEnabled == false) {
                    this.$mdToast.show({
                        template: "<md-toast class=\"custom-toast\">" +
                            "<h4>Two-Factor Authentication Email Sent</h4>" +
                            "<div class=\"custom-toast-content\">" +
                            "We've sent a verification email to the selected user. They'll need to enter a security code on their next login to complete the setup.</div>" +
                            "</md-toast>",
                        position: "top right",
                        hideDelay: 3000
                    });
                } else {
                    this.$mdToast.show(
                        this.$mdToast.simple()
                            .textContent(msg)
                            .position("top right")
                            .hideDelay(3000)
                    );
                }
            });
    }
}



// WEBPACK FOOTER //
// ./sources/components/users/users.controller.js